'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagPickerList_unstable", {
    enumerable: true,
    get: function() {
        return useTagPickerList_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactcombobox = require("@fluentui/react-combobox");
const _TagPickerContext = require("../../contexts/TagPickerContext");
const _reactutilities = require("@fluentui/react-utilities");
const useTagPickerList_unstable = (props, ref)=>{
    const triggerRef = (0, _TagPickerContext.useTagPickerContext_unstable)((ctx)=>ctx.triggerRef);
    const popoverRef = (0, _TagPickerContext.useTagPickerContext_unstable)((ctx)=>ctx.popoverRef);
    const popoverId = (0, _TagPickerContext.useTagPickerContext_unstable)((ctx)=>ctx.popoverId);
    const open = (0, _TagPickerContext.useTagPickerContext_unstable)((ctx)=>ctx.open);
    return {
        open,
        components: {
            root: _reactcombobox.Listbox
        },
        root: _reactutilities.slot.always({
            ...(0, _reactcombobox.useListboxSlot)(props, (0, _reactutilities.useMergedRefs)(popoverRef, ref), {
                state: {
                    multiselect: true
                },
                triggerRef,
                defaultProps: {
                    id: popoverId
                }
            }),
            role: 'listbox'
        }, {
            elementType: _reactcombobox.Listbox
        })
    };
};
